function cov_1usshp8dgl() {
  var path = "/app/src/constants/subvention-country.ts";
  var hash = "257ee6b55bd7e600b3fb96969aff364376a84e71";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/constants/subvention-country.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 49
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "257ee6b55bd7e600b3fb96969aff364376a84e71"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1usshp8dgl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1usshp8dgl();
import { CountryName } from 'src/types/country-name';
export var SUBVENTION_COUNTRY = (cov_1usshp8dgl().s[0]++, [CountryName.saudi, CountryName.emirates]);